// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bc3d142f","453":"3257c68d"}[chunkId] + ".chunk.js";
};